module.exports = __webpack_public_path__ + "static/media/empty.b588722b.svg";